































import {Component, Vue, Watch} from 'vue-property-decorator';
import JdsMeridianBadge from "@/design-system/patterns/Meridian/JdsMeridianBadge.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiButton from "@/components/JdiButton.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsMeridianItem from "@/design-system/patterns/Meridian/JdsMeridianItem.vue"
import JdsMeridian from "@/design-system/patterns/Meridian/JdsMeridian.vue"
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdsLocaleProvider from "@/design-system/foundation/JdsLocaleProvider.vue"
import JdsTextProvider from "@/design-system/foundation/JdsTextProvider.vue"
import JdsTeleportProvider from "@/design-system/foundation/JdsTeleportProvider.vue"
import JdsAppFrame from "@/design-system/patterns/AppFrame/JdsAppFrame.vue"

@Component({
    components: {
        JdsAppFrame,
        JdsTeleportProvider,
        JdsTextProvider,
        JdsLocaleProvider,
        JdsGlyph,
        JdsMeridian,
        JdsMeridianBadge,
        JdsMeridianItem,
        JdiStatus,
        JdiButton,
        JdsIcon,
        JdiContent,
        JdiPreview
    }
})
export default class AdminPlayground extends Vue {

    openNav = false
    loading = false

    created() {
        this.$router.beforeEach((to, from, next) => {
            this.loading = true
            next()
        })
        this.$router.afterEach((to, from) => {
            this.loading = false
        })
    }

    @Watch('$route', {immediate: true})
    handleNavSize() {
        this.openNav = this.$route.matched.some(({name}) => name === 'playground.dashboard');
    }

    get console() {
        return console;
    }
}
